import { IonButton } from '@ionic/react';
import { useHistory } from 'react-router';
import AuthLayout from '../components/AuthLayout';
import { IoMdDoneAll } from 'react-icons/io';

const PasswordResetSuccess = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push('login');
  };

  return (
    <AuthLayout>
      <section className="w-full h-auto flex flex-col items-center justify-center md:px-[35%] px-6">
        <div className="w-[25dvw] md:w-[8dvw] h-auto aspect-square rounded-full bg-white flex  items-center justify-center mt-4 p-8 md:p-10 overflow-hidden">
          <IoMdDoneAll size="100%" className="text-secondary" />
        </div>
        <div className="w-full flex flex-col items-center justify-center font-roboto text-primary mt-4 py-2 text-center">
          <h2 className="text-2xl md:text-3xl font-medium ">Password Reset</h2>
          <p className="text-base font-light mt-2 ">
            Your password has been successfully reset. Click below to log in
          </p>
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          <IonButton
            type="submit"
            onClick={handleClick}
            color="secondary"
            expand="block"
            fill="solid"
            className="w-full font-roboto text-base font-medium"
          >
            LogIn
          </IonButton>
        </div>
      </section>
    </AuthLayout>
  );
};

export default PasswordResetSuccess;
